import type { ApiErrorBody } from '../shared/types'

export class ApiError extends Error {
  constructor(
    message: string,
    readonly status: number,
    readonly code: string,
    readonly details?: unknown,
  ) {
    super(message)
  }
}

export class ConflictError extends ApiError {
  readonly current: unknown
  constructor(message: string, details?: any) {
    super(message, 409, 'VERSION_CONFLICT', details)
    this.current = details?.current
  }
}

export async function api<T>(path: string, init?: RequestInit): Promise<T> {
  const response = await fetch(`/api/v1${path}`, {
    credentials: 'include',
    ...init,
    headers: {
      ...(init?.body ? { 'Content-Type': 'application/json' } : {}),
      ...init?.headers,
    },
  })
  const body = (await response.json().catch(() => null)) as { data: T } | ApiErrorBody | null
  if (!response.ok) {
    const error = body && 'error' in body ? body.error : undefined
    if (response.status === 409)
      throw new ConflictError(error?.message ?? 'Conflict', error?.details)
    throw new ApiError(
      error?.message ?? `Request failed (${response.status})`,
      response.status,
      error?.code ?? 'REQUEST_FAILED',
      error?.details,
    )
  }
  return (body as { data: T }).data
}
